import {
	CHANGE_DEVICE,
	INIT,
	SITE_INIT,
	OPEN_MENU,
	OPEN_CART,
	SET_QUERY,
	REMOVE_NOTIFICATION,
	CHANGE_LANGUAGE,
	UPDATE_EVENT_DETAILS,
	UPDATE_EVENT_DETAILS_ERRORS,
	PARTICIPANTS_REGISTERED,
	PARTICIPANTS_ERROR,
} from '../actions/environment';
import { setCookie } from '../utils/dom';
import { urlify } from '../utils/string';

const initialState = {
	properties: {
		openCart: false,
		siteInitiated: false,
		siteUpdated: false,
	},
	setup: {},
	header: {},
	footer: {},
	searchInputText: '',
	hashLocation: '',
	navigation: {
		open: false,
	},
	pagination: {},
	favourites: [],
	eventDetails: {
		allowFriends: false,
		subscribeToNewsletter: false,
		acceptTerms: false,
		serverErrors: [],
		errors: {},
	},
};

const environment = (state = initialState, action) => {
	switch (action.type) {
		case INIT:
			return {
				...state,
				properties: {
					...state.properties,
					siteClosed: action.initData.siteClosed || false,
					siteInitiated: true,
				},
				setup: {
					...state.setup,
					...action.initData.setup,
				},
				header: {
					...state.header,
					...action.initData.header,
				},
				magazineSnippets: action.initData.magazineSnippets,
				footer: {
					...state.footer,
					...action.initData.footer,
				},
				navigation: {
					...state.navigation,
					...action.initData.navigation,
				},
			};

		case CHANGE_DEVICE:
			return {
				...state,
				setup: {
					...state.setup,
					breakPoint: action.breakPoint,
				},
			};

		case 'SITE_UPDATED':
			return {
				...state,
				properties: {
					...state.properties,
					siteUpdated: true,
				},
			};

		case 'UPDATE_PAGINATION':
			return {
				...state,
				pagination: {
					...state.pagination,
					[action.currentPath]: action.currentPage,
				},
			};

		case 'UPDATE_HASH':
			return {
				...state,
				hashLocation: action.hash,
			};

		case 'PAGE_PATHS':
			return {
				...state,
				pageType: action.pageType,
				pagePaths: action.paths,
			};

		case SITE_INIT:
			return {
				...state,
				properties: {
					...state.properties,
					siteInitiated: true,
				},
			};

		case 'UPDATE_COUNTRY': {
			if (typeof document !== 'undefined') {
				// Is set on server unconditionally so only valid for client
				setCookie('settings', [state.setup.language, action.country, parseInt(action.market, 10), parseInt(action.pricelist, 10)]);
			}
			const shippable = state.setup.countries[action.country].shipTo;
			return {
				...state,
				setup: {
					...state.setup,
					country: action.country,
					market: action.market,
					pricelist: action.pricelist,
					unableToSendToCountry: !shippable,
				},
			};
		}

		case CHANGE_LANGUAGE: {
			if (typeof document !== 'undefined') {
				// Is set on server unconditionally so only valid for client
				setCookie('settings', [action.language, state.setup.country, parseInt(state.setup.market, 10), parseInt(state.setup.pricelist, 10)]);
			}
			return {
				...state,
				setup: {
					...state.setup,
					language: action.language,
				},
			};
		}

		case OPEN_MENU:
			return {
				...state,
				navigation: {
					...state.navigation,
					open: !state.navigation.open,
				},
			};

		case OPEN_CART:
			return {
				...state,
				properties: {
					...state.properties,
					openCart: true,
				},
			};

		case 'CLOSE_CART':
			return {
				...state,
				properties: {
					...state.properties,
					openCart: false,
				},
			};

		case 'TOGGLE_CART':
			return {
				...state,
				properties: {
					...state.properties,
					openCart: !state.properties.openCart,
				},
			};

		case SET_QUERY:
			return {
				...state,
				setup: {
					...state.setup,
					[action.key]: action.value,
				},
			};

		case REMOVE_NOTIFICATION:
			return {
				...state,
				header: {
					...state.header,
					[action.notificationType]: (
						state.header[action.notificationType].map((notification) => {
							if (urlify(notification.name) === action.notificationName) {
								return {
									...notification,
									removed: true,
								};
							}
							return notification;
						})
					),
				},
			};

		case 'SEARCH':
			return {
				...state,
				searchInputText: action.text,
			};

		case 'TOGGLE_FAVOURITE': {
			let favourites = [...state.favourites];
			const index = favourites.indexOf(action.productId);

			if (index === -1) {
				favourites = [...favourites, action.productId];
			} else {
				favourites = [...favourites.slice(0, index), ...favourites.slice(index + 1)];
			}

			localStorage.setItem('favourites', JSON.stringify(favourites));

			return {
				...state,
				favourites,
			};
		}

		case 'UPDATE_FAVOURITES':
			return {
				...state,
				favourites: [...action.favourites],
			};

		case UPDATE_EVENT_DETAILS:
			return {
				...state,
				eventDetails: {
					...state.eventDetails,
					[action.id]: action.value ? action.value : !state.eventDetails[action.id],
					eventRegistrationFailed: false,
					eventRegistrationSucceded: false,
					serverErrors: [],
				},
			};

		case UPDATE_EVENT_DETAILS_ERRORS:
			return {
				...state,
				eventDetails: {
					...state.eventDetails,
					errors: {
						...state.eventDetails.errors,
						[action.id]: action.error,
					},
				},
			};

		case PARTICIPANTS_REGISTERED:
			return {
				...state,
				eventDetails: {
					...initialState.eventDetails,
					eventRegistrationSucceded: true,
					eventRegistrationFailed: false,
					serverErrors: [],
				},
			};

		case PARTICIPANTS_ERROR:
			return {
				...state,
				eventDetails: {
					...state.eventDetails,
					eventRegistrationFailed: true,
					eventRegistrationSucceded: false,
					serverErrors: action.errors ? [...action.errors] : [],
				},
			};

		default:
			return state;
	}
};

export { initialState as environmentState };
export default environment;
